/**
 * DAT myClaim Service
 * Handles authentication and iframe URL generation for DAT integration
 */

import { getBackendUrl } from '../utils/apiUrl';

/**
 * Fetch DAT token from backend
 * The backend handles the actual DAT API call with credentials
 */
export async function fetchDatToken() {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${getBackendUrl()}/api/dat/token`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || `HTTP error: ${response.status}`);
  }

  const data = await response.json();
  
  // Debug: Log JWT payload
  try {
    const parts = data.token.split('.');
    if (parts.length === 3) {
      console.log('DAT JWT Payload:', JSON.parse(atob(parts[1])));
    }
  } catch (e) {
    console.log('Token parse info:', e.message);
  }

  return data.token;
}

/**
 * Build myClaim iframe URL
 * @param {string} token - DAT authentication token
 * @param {string} claimId - Optional claim ID to open
 * @param {string} subView - View type: 'glass', 'vro_calculation', 'bundle_valuation'
 * @returns {string} Full iframe URL
 */
export function buildMyClaimUrl(token, customerNumber, login, claimId = null, subView = 'glass') {
  let url = `https://www.dat.de/myClaim/json/security/Login?token=${token}&customerNumber=${customerNumber}&login=${login}`;

  if (claimId) {
    const redirect = `inbox.jsp#claim?claim=${claimId}&subView=${subView}&extendedFullscreen=true`;
    url += `&redirect=${encodeURIComponent(redirect)}`;
  } else {
    // Open to inbox with new claim dialog
    const redirect = 'inbox.jsp';
    url += `&redirect=${encodeURIComponent(redirect)}`;
  }

  return url;
}

/**
 * Check if user has DAT credentials configured
 */
export async function checkDatCredentials() {
  const token = localStorage.getItem('token');
  
  try {
    const response = await fetch(`${getBackendUrl()}/api/dat/credentials/status`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      return { hasCredentials: false, message: 'Fehler beim Prüfen der Credentials' };
    }

    return await response.json();
  } catch (error) {
    console.error('DAT credentials check error:', error);
    return { hasCredentials: false, message: error.message };
  }
}

/**
 * Get subView title for display
 */
export function getSubViewTitle(subView) {
  switch (subView) {
    case 'glass':
      return 'DAT Glasberechnung';
    case 'vro_calculation':
      return 'DAT Schadenkalkulation';
    case 'bundle_valuation':
      return 'DAT Wertermittlung';
    default:
      return 'DAT myClaim';
  }
}
